import { application } from '@modules/husleie-framework/src/features/nor/Application';
import type Features from '@modules/store/common/types/Features.entity';

export function getFeatures(): Features {
  return {
    regionToggles: {
      application,
      tenancySubscripition: {
        isDisabled: false,
      },
    },
  };
}
